import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { BookingActivity, BookingBehavior } from 'src/app/shared/Models/SessionBookingDTO';
import { SlotLockResultDTO } from 'src/app/shared/Models/SlotLockModels';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { environment } from 'src/environments/environment';
import { urlConfig } from '../../shared/constants/url-config'
@Component({
  selector: 'app-activity-booking',
  templateUrl: './activity-booking.component.html',
  styleUrls: ['./activity-booking.component.scss']
})
export class ActivityBookingComponent implements OnInit, OnDestroy {
  selectedIndex: number = 0;
  bookingType_config: FieldConfig[];
  bookingValue = BookingActivity.ClassBooking;
  isSessionClass = BookingBehavior.ClassOrSession;
  Operation = operationType;
  Subscription: Subscription = new Subscription();
  ActivityBookingType = BookingActivity;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  environment = environment;
  constructor(public activityService: GuestService) {
    this.Subscription.add(this.activityService.bookingSection$.subscribe(bookingData => {
      this.bookingValue = bookingData;
    }));
    this.Subscription.add(this.activityService.restaurantWidgetSettings$.subscribe(value => {
      this.activityService.imageUrl = environment.BaseUrl + urlConfig.widgetImageURL + value.RestaurantId;
    }));
  }
  ngOnInit(): void {
  }


  setBookingType(event) {
    this.bookingValue = Number(event.value);
    this.activityService.bookingSection$.next(this.bookingValue);
    this.activityService.bookingType$.next(event.value);
    this.activityService.membershipId = null;
    if (this.bookingValue && this.activityService.lockMultipleResult) {
      const lockData = Object.values(this.activityService.lockMultipleResult) as SlotLockResultDTO[];
      const LockIds = lockData.map(x => x?.SlotLockIdDTO?.Id);
      this.Subscription.add(this.activityService.releaseMultiple(LockIds).subscribe(data => {
        this.activityService.lockMultipleResult = null;
        this.activityService.offTimer();
      }));
    }
  }
  ngOnDestroy(): void {
    if (this.Subscription) { this.Subscription.unsubscribe(); }
  }

}
